<template>
    <div class="searchBar white_bg" v-show="visible">
        <div class="paddingH16 flexLayout" style="padding-top: 4px; padding-bottom: 4px; line-height: 36px;">

            <div style="width: 50px">
                <span class="icon leftAngleBracketIcon floatL" style="margin-top: 7px;" @click="reset()"></span>
            </div>

            <searchInputbox ref="searchInputbox" @change="onChangeKeywords"/>

            <div class="searchBtn colorF55050 alignR f16" style="width: 40px;color:#FFA724;" @click="search()">搜索</div>
        </div>
    </div>
</template>

<script>
import searchInputbox   from "./searchInputbox";

export default {
    name: "searchBar",
    components : { searchInputbox },
    data() {
        return {
            visible : false
        }
    },
    methods : {
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
        },

        onChangeKeywords() {
            this.search();
        },

        search() {
            let value = this.$refs.searchInputbox.value;
            this.$emit('search', value);
        },

        reset() {
            this.$refs.searchInputbox.cleanValue();
            this.hide();
        },

        focus() {
            this.$refs.searchInputbox.focus();
        }
    }
}
</script>

<style lang="scss" scoped>
.searchBar {
    position: fixed;
    z-index: 1;
    width: 100%;
    left: 0;
    top: 0;
}
</style>
